import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import carData from '../../data/carSelectionData';
import Constants from '../../data/constants';
import carImages from '../../data/carImages';

class CarSelectionBlock extends Component {
    constructor(props) {
        super(props);
        const { models } = props;
        this.elems = {};
        this.state = {
            model: models[0],
            selState: { width: '100%' }
        }
    }

    componentDidMount() {
        this.setBackDrop();
        window.addEventListener('resize', debounce(() => this.setBackDrop(), 250));
    }

    setModel(val) {
        this._model = val;
    }

    getModel() {
        return this._model;
    }

    /**
     * Set refreshed props for the backdrop.
     * Either by a specific car (after selection) or take the current model (after resizing screen).
     *
     * @param whichCar
     */
    setBackDrop = (whichCar = null) => {
        const { model } = this.state;
        const currEl = this.elems[whichCar ? whichCar : model];

        if (currEl) {
            this.setState({
                selState: {
                    width: currEl.clientWidth + 6 + 'px',
                    height: currEl.clientHeight + 6 + 'px',
                    left: currEl.offsetLeft + 'px',
                    top: currEl.offsetTop + 'px'
                }
            });
        }
    }

    handleModelSelect = e => {
        const selection = e.target.getAttribute('data-model');
        this.props.setModel(selection);
        this.setState({ model: selection });
        this.setBackDrop(selection);
    }

    render() {
        const { selState, model } = this.state,
              { models } = this.props,
              { name } = carData;

        return (
            <div>
                <div className="car-selection" onClick={this.handleModelSelect}>
                    {models.map((m, i) => {
                        let isActive = m === model;
                        return (
                            <div
                                key={i}
                                className={'car-model model-' + m.toLowerCase()}
                                style={{backgroundImage: `url(${Constants().RESOURCE_BASE_URL}${carImages[m.toLowerCase()]})`}}
                                data-model={m}
                                ref={input => { this.elems[m] = input }}
                            >
                                <span className={'model-name' + (isActive ? ' active' : '')}>{name[m]}</span>
                            </div>
                        )
                    })}
                    <div className="car-selector" style={selState} />
                </div>
            </div>
        )
    }
}

export default connect(({ flags }) => ({
    models: flags.availableModels,
}))(CarSelectionBlock);
